import { Card, Col, Row } from "reactstrap";
import { Href } from "../../../Constant";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { SocailAppCallBackType } from "../../../Type/SocialAppType";
import UserProfileIcon from "./UserProfileIcon";
import NavBarMain from "./NavBarMain";

const UserProfile = ({ callback }: SocailAppCallBackType) => {
  return (
    <Row>
      <Col sm="12" className="box-col-12">
        <Card className="hovercard text-center">
          <div className="cardheader socialheader" />
          <div className="user-image">
            <div className="avatar">
              <Image alt="user" src={dynamicImage("user/1.jpg")} />
            </div>
            <div className="icon-wrapper">
              <a href={Href}><i className="icofont icofont-pencil-alt-5" /></a>
            </div>
            <UserProfileIcon />
          </div>
          <div className="info market-tabs p-0">
            <NavBarMain callback={callback} />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default UserProfile;
